import React from 'react';
import type { MenuItem } from '../../types/menu';

export interface MenuCardProps {
  item: MenuItem;
  className?: string;
}

/**
 * MenuCard Component — elegant restaurant menu list style
 * No box/card borders — open, airy look like a real menu
 */
export const MenuCard: React.FC<MenuCardProps> = ({ item, className = '' }) => {
  return (
    <article
      className={`group relative py-5 border-b border-white/5 last:border-0 ${className}`}
      aria-label={`Gericht: ${item.name}`}
    >
      {/* Gold accent bar on hover */}
      <div
        className="absolute left-0 top-0 bottom-0 w-0.5 bg-[#c9a84c] opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        aria-hidden="true"
      />

      <div className="pl-4">
        {/* Dish Name */}
        <h3 className="text-base font-semibold text-[#c9a84c] tracking-wide mb-1.5 group-hover:text-[#d4b55e] transition-colors duration-200">
          {item.name}
        </h3>

        {/* Description */}
        {item.description && (
          <p className="text-sm text-gray-400 leading-relaxed font-light">
            {item.description}
          </p>
        )}
      </div>
    </article>
  );
};
